import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { loginAPI, getMeAPI } from '@/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('admin_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await getMeAPI();
      setUser(res.data);
    } catch {
      localStorage.removeItem('admin_token');
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (username, password) => {
    const res = await loginAPI(username, password);
    localStorage.setItem('admin_token', res.data.token);
    setUser(res.data.user);
    return res.data; // includes must_change_password
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
